<template>
  <div v-if="links.length > 3" class="flex flex-wrap gap-2 items-center justify-between">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links">
        <div
          v-if="link.url === null"
          :key="key"
          class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded"
          v-html="link.label" />
        <Link
          v-else
          :key="`link-${key}`"
          class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded"
          :class="{ 'bg-white': link.active }"
          :href="link.url"
          v-html="link.label" />
      </template>
    </div>
    <select
      v-if="withPerPage"
      aria-label="Rows per page"
      class="px-2 py-2 text-sm leading-4 bg-white border focus:border-indigo-500 rounded"
      :value="currentPerPage"
      @change="onPerPage">
      <option
        v-for="opt in perPageOptions"
        :key="opt"
        :value="opt">
        {{ opt }} / page
      </option>
    </select>
  </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3'

export default {
    components: {
        Link,
    },
    props: {
        links: Array,
        withPerPage: { type: Boolean, default: false },
    },
    data () {
        return {
            // ponytail: options hardcoded to the server whitelist (10/20/30/50/100); pass via prop if another page needs a different set.
            perPageOptions: [10, 20, 30, 50, 100],
        }
    },
    computed: {
        currentPerPage () {
            const value = Number(new URLSearchParams(window.location.search).get('per_page'))
            return this.perPageOptions.includes(value) ? value : 10
        },
    },
    methods: {
        onPerPage (event) {
            const params = new URLSearchParams(window.location.search)
            params.set('per_page', event.target.value)
            params.delete('page')
            router.visit(`${window.location.pathname}?${params}`, { preserveState: true, preserveScroll: true })
        },
    },
}
</script>
